import { css } from 'lit';
import componentStyles from '../../styles/component.styles';
export default css `
    ${componentStyles}
    :host {
        font-family: var(--sgdf-font-sans);
        color: var(--sgdf-color-default);
        display: block;
    }

    .participant-item {
        padding: var(--sgdf-spacing-x-small);
    }

    .participant-item:not(.card) {
        border-bottom: 1px solid rgba(0, 0, 0, 0.125);
    }

    .participant-item.card {
        border-radius: var(--sgdf-border-radius-large);
        margin-bottom: var(--sgdf-spacing-small);
        border: 1px solid rgba(0, 0, 0, 0.125);
    }

    .margin-right {
        margin-right: 0.5em;
    }

    .info {
        color: var(--sgdf-color-light);
    }
`;
//# sourceMappingURL=ParticipantItem.styles.js.map